import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '23fr 1fr',
    columnGap: 5,
    backgroundColor: (props: { isOdd: boolean }) =>
      props.isOdd == true
        ? theme.palette.grey[300]
        : theme.palette.background.default,
    borderRadius: 10,
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    height: 100,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  menuIcon: {
    justifySelf: 'end',
    marginRight: 20
  },
  tableRowExceptMenuItem: {
    display: 'grid',
    columnGap: 5,
    gridTemplateColumns: '4fr 3fr 2fr 2fr 5fr 5fr',
    height: '100%'
  },
  lastFetched: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    rowGap: 5
  },
  maxmin: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr'
  }
}))

export default useStyles
